/*eslint-disable no-undef,no-redeclare,no-empty,no-unused-vars */
import April from '../../ALizard/April'

export default ()=>{
    April.define("log.cost", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            args.scene.member[args.player].SP-=args.cost;
        }else if(args.opr == 'back'){
            args.scene.member[args.player].SP+=args.cost;
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", {value: "call DisplayComponent/skill.cost"});
            args.tweener
            .call(function(_args){
              ch.SP -= _args.cost;
            }, null, [args]);
        }
    });
    
    April.define("DisplayComponent/skill.miss", function(args){
      if(args.opr == 'split'){
          return false;
      }else if(args.opr == 'next'){
      }else if(args.opr == 'back'){
      }else if(args.opr == 'play'){
        var scene=args.scene;
        var ch = args.scene.member[args.player];
        scene.flare("act_console", {value:"call DisplayComponent/skill.miss"});
        args.tweener
        .call(function(_args){
            BattleScene.Fukidasi("img/ui/F_miss.png", 110, 55)
            .addChildTo(ch).setPosition(0,0);
        }, null, [args])
        .wait(1000);
      }
    });    
}
